import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

export { refreshedOutline } from "./style";

type OwnProps = Omit<Mui.ButtonProps, "variant" | "classes">;

interface Props extends OwnProps, WithStyles<typeof styles> {}

/**
 * The refreshed Secondary button (MAX-4419): outlined, primary, with the design kit's 2px outline.
 * withStyles merges the root class into `className` itself (the sheet has only root), so a
 * consumer's className still wins, and it forwards the ref, so this can be a Tooltip's child.
 */
const Component = React.forwardRef<HTMLButtonElement, Props>(({ classes, color = "primary", ...props }, ref) => (
	<Mui.Button ref={ref} variant="outlined" color={color} {...props} />
));

export const OutlinedButton = withStyles(Component, styles);
